function tryAttachOkendoFaqEventListener() {
	const coinItem = document.querySelector(".okeLoyalty--floatingWidget .c-widget-body .c-card:has(.fa-coins)");
    if (!coinItem) {
        return;
    }

    coinItem.insertAdjacentHTML('beforebegin', '<div class="u-marginTop--6"><div style="cursor: pointer;" class="c-actionButton-label okendo-faq-open-custom"><div style="font-weight: 400; text-align: center;" class="u-textTransform--capitalize c-actionButton-title u-textStyle--subtitle"><u> ››› Sıkça Sorulan Sorular ››› </u></div></div></div>');

    const faqOpenButton = document.querySelector('.okendo-faq-open-custom');

    faqOpenButton.addEventListener('click', function () {
        const targetDiv = document.querySelector('.c-titleBar-button:has(.fa-circle-question)');
        targetDiv.click();
    });
}

function observeFloatingWidget() {
    tryAttachOkendoFaqEventListener()
	const observer = new MutationObserver((mutationsList, observer) => {     
        const faqOpenButton = document.querySelector('.okendo-faq-open-custom');
        if (faqOpenButton) {
            return;
        }

        tryAttachOkendoFaqEventListener();
	});

    const widgetContentDiv = document.querySelector('[data-oke-loyalty-widget]');

	observer.observe(widgetContentDiv, {
		childList: true,
		subtree: true,
	});
}

const widgetContentDiv = document.querySelector('[data-oke-loyalty-widget]');

if (widgetContentDiv) {
    observeFloatingWidget();
}
else {
    document.addEventListener('oke-loyalty-widget-loaded', () => { observeFloatingWidget(); });
}